<script>

    import { userStore, adminStore } from '../stores'
    import { isPermission, getPermission } from '../$methods/permissions.methods'

    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'
    import InfoTag from '../$components/info.tag.svelte'

</script>

{#if $userStore}

    <InfoCard subtitle="Detalles del usuario" title={ $userStore.name }>
        <span slot="tag">
            {#if $userStore.status === 'enabled'}
                <InfoTag color="success" icon="fas fa-check-circle" label={ TranslateMethods.get($userStore.status) } />
            {:else if $userStore.status === 'disabled'}
                <InfoTag color="danger" icon="fas fa-ban" label={ TranslateMethods.get($userStore.status) } />
            {:else}
                <InfoTag color="warning" icon="fas fa-clock" label={ TranslateMethods.get($userStore.status) } />
            {/if}
        </span>

        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Tipo de usuario" icon="fas fa-user" value={ TranslateMethods.get($userStore.role) } bold />
            <InfoField label="Empresa" icon="fas fa-building" value={ $userStore.corporate || '—' } />
            <InfoField label="Nombre completo" icon="fas fa-id-card" value={ $userStore.name } />
            <InfoField label="Correo" icon="fas fa-envelope" value={ $userStore.email } />
            <InfoField label="Teléfono" icon="fas fa-phone" value={ $userStore.phone || '—' } />
            <InfoField label="CLABE" icon="fas fa-university" value={ $userStore.clabe || '—' } />
            <InfoField label="Facturación automática" icon="fas fa-file-invoice" value={ $userStore.autoInvoice ? 'Sí' : 'No' } />
            <InfoField label="Puede cotizar" icon="fas fa-file-invoice-dollar" value={ TranslateMethods.get($userStore.statusQuotation) } color={ $userStore.statusQuotation === 'enabled' ? 'success' : 'danger' } />
            <InfoField label="Puede generar envíos" icon="fas fa-shipping-fast" value={ TranslateMethods.get($userStore.statusShipment) } color={ $userStore.statusShipment === 'enabled' ? 'success' : 'danger' } />
            <InfoField label="Etiqueta de precios" icon="fas fa-tags" value={ $userStore.pricingTag || '—' } />
            <InfoField label="Fecha de creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($userStore.created) } bold />
            {#if $userStore.disabled}
                <InfoField label="Fecha de baja" icon="far fa-calendar-times" value={ DateMethods.dateTimeLarge($userStore.disabled) } color="danger" />
            {/if}
        </div>
    </InfoCard>

    {#if $userStore.adviser || $userStore.seller}
        <InfoCard subtitle="Asignaciones">
            <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
                {#if $userStore.adviser}
                    <InfoField label="Asesor" icon="fas fa-user-tie" size="half">
                        <p class="is-size-6 has-text-weight-medium">{ $userStore.adviser.name }</p>
                        <p class="is-size-7 has-text-grey">{ $userStore.adviser.email }</p>
                    </InfoField>
                {/if}
                {#if $userStore.seller}
                    <InfoField label="Vendedor" icon="fas fa-user-tag" size="half">
                        <p class="is-size-6 has-text-weight-medium">{ $userStore.seller.name }</p>
                        <p class="is-size-7 has-text-grey">{ $userStore.seller.email }</p>
                    </InfoField>
                {/if}
            </div>
        </InfoCard>
    {/if}

    {#if $userStore.permissions?.length}
        <InfoCard subtitle="Permisos">
            <div class="tags">
                {#each $userStore.permissions as permission}
                    <span class="tag is-light" style="border-radius: 5px;">{ getPermission(permission) }</span>
                {/each}
            </div>
        </InfoCard>
    {/if}

    {#if isPermission($adminStore, 'UsersView.User.Update')}
        <div class="items-end mt-4">
            <div class="buttons">
                <ButtonModal modalId="user_update_modal" text="Actualizar" icon="edit" />
            </div>
        </div>
    {/if}

{/if}
